/*
 * @file: æ»å¨æå¡
 * @author: linkun.he
 * @Date: 2019-03-09 18:56:26
 */
import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";

import { WINDOW } from "@ithinkdt/shared/utils";

@Injectable({ providedIn: "root" })
export class ScrollService {
  constructor(
    @Inject(WINDOW) private win: any,
    @Inject(DOCUMENT) private doc: any
  ) {}

  /**
   * è·åæ»å¨æ¡ä½ç½®
   * @param element æå®åç´ ï¼é»è®¤ `window`
   */
  getScrollPosition(element?: Element): [number, number] {
    if (element && element !== this.win) {
      return [element.scrollLeft, element.scrollTop];
    } else {
      return [this.win.pageXOffset, this.win.pageYOffset];
    }
  }

  /**
   * è®¾ç½®æ»å¨æ¡ä½ç½®
   * @param element æå®åç´ 
   */
  scrollToPosition(
    element: Element | Window,
    position: [number, number]
  ): void {
    (element || this.win).scrollTo(position[0], position[1]);
  }

  /**
   * è®¾ç½®æ»å¨æ¡è³æå®åç´ 
   * @param element æå®åç´ ï¼é»è®¤ `document.body`
   * @param topOffset åç§»å¼ï¼é»è®¤ `0`
   */
  scrollToElement(element?: Element, topOffset = 0) {
    if (!element) {
      element = this.doc.body;
    }

    element.scrollIntoView();

    const w = this.win;
    if (w && w.scrollBy) {
      w.scrollBy(0, element.getBoundingClientRect().top - topOffset);

      if (w.pageYOffset < 20) {
        w.scrollBy(0, -w.pageYOffset);
      }
    }
  }

  /**
   * æ»å¨è³é¡¶é¨
   * @param topOffset åç§»å¼ï¼é»è®¤ `0`
   */
  scrollToTop(topOffset = 0) {
    this.scrollToElement(this.doc.body, topOffset);
  }
}
